import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';

type NotifyTenantPageProps = {
  togglePrevPage: () => void;
  toggleNextPage: () => void;
};

class NotifyTenantPage extends React.Component<NotifyTenantPageProps> {
  static defaultProps = {
    togglePrevPage: () => {},
    toggleNextPage: () => {},
  };

  togglePrevPage = () => this.props.togglePrevPage();

  toggleNextPage = () => this.props.toggleNextPage();

  render(): React.ReactNode {
    return (
      <>
        <Text type="h3">Monthly rent</Text>
        <SpacerRow>
          <Text>We recommend notifying your tenant before changing the rent amount (typically 30 days before).</Text>
        </SpacerRow>
        <SpacerRow size="sm">
          <Button type="primary" full onClick={this.toggleNextPage}>
            I already notified my tenant
          </Button>
        </SpacerRow>
        <SpacerRow size="sm">
          <Button type="tertiary" full onClick={this.togglePrevPage}>
            OK, I&apos;ll come back
          </Button>
        </SpacerRow>
      </>
    );
  }
}

export default NotifyTenantPage;
